var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Schema, type, MapSchema } from "@colyseus/schema";
import { Player } from "./Player.js";
import { Npc } from "./Npc.js";
export class MallState extends Schema {
    constructor() {
        super(...arguments);
        this.players = new MapSchema();
        this.npcs = new MapSchema();
    }
}
__decorate([
    type({ map: Player })
], MallState.prototype, "players", void 0);
__decorate([
    type({ map: Npc })
], MallState.prototype, "npcs", void 0);
//# sourceMappingURL=MallState.js.map